// import React, { useEffect, useState } from 'react';
// import { toast } from 'react-toastify';
// import { useAppContext } from '../../context/AppContext';
// import { Label, Input, Select } from '../../Shared';
// import axios from 'axios';
// import getUSPSSortation from '../../util/Sortation';

// const AddProduct = ({
//   onClose,
//   editItemId,
//   setReset,
//   reset,
//   product,
//   setProduct,
//   setEditItemId,
//   setCalcOpen,
// }) => {
//   const { axiUrl, user } = useAppContext();
//   const [defaultProducts, setDefaultProducts] = useState([]);
//   const [sortationResult, setSortationResult] = useState({
//     mailShape: '',
//     aspectRatio: '',
//     parcelWarning: '',
//   });

//   const [formData, setFormData] = useState(
//     product
//       ? {
//           name: product.name,
//          mailShape:product.mailShape,
//          aspectRatio:product.aspectRatio,
//           weight: product.weight,
//           weightUnit: product.weightUnit || 'OZ',
//           thickness: product.thickness,
//           width: product.width,
//           length: product.length,
//           paperType: product.paperType || '',
//           company: company || null,
//           user: user._id,
//         }
//       : {
//           mailShape:'',
//           aspectRatio:0,
//           weight: '',
//           weightUnit: 'OZ',
//           thickness: '',
//           width: '',
//           length: '',
//           paperType: '',
//           company: company || null,
//           user: user._id,
//         }
//   );

//   useEffect(() => {
//     const getdefaults = async () => {
//       try {
//         const res = await axios.get(`${axiUrl}/products/getdefaultproducts`);
//         setDefaultProducts(res.data.data);
//       } catch (err) {
//         console.error('Error fetching default products:', err);
//         toast.error('Failed to load default products');
//       }
//     };
//     getdefaults();
//   }, []);

//   const calculateSortation = () => {
//     const { width, length, thickness, weight, weightUnit } = formData;

//     const widthNum = parseFloat(width) || 0;
//     const lengthNum = parseFloat(length) || 0;
//     const thicknessNum = parseFloat(thickness) || 0;
//     const weightNum = parseFloat(weight) || 0;

//     if (widthNum <= 0 || lengthNum <= 0 || thicknessNum <= 0 || weightNum <= 0) {
//       setSortationResult({
//         mailShape: 'Invalid',
//         aspectRatio: 'N/A',
//         parcelWarning: 'Please enter valid positive values for width, length, thickness, and weight.',
//       });
//       return false;
//     }

//     const sortationInput = {
//       productHeight: widthNum,
//       productLength: lengthNum,
//       productThickness: thicknessNum,
//       productWeight: weightUnit === 'lbs' ? weightNum * 16 : weightNum,
//       imBarcode: true,
//       isUniformThickness: true,
//       isFlexible: true,
//       presortOnly: false,
//     };

//     console.log('Sortation Input:', sortationInput);

//     const result = getUSPSSortation(sortationInput);

//     setSortationResult({
//       mailShape: result.error ? 'Invalid' : result.selectedCategory || 'N/A',
//       aspectRatio: result.aspectRatio || 'N/A',
//       parcelWarning: result.error || 'None',
//     });
   

//     return !result.error;
//   };

//   useEffect(() => {
//     if (formData.width && formData.length && formData.thickness && formData.weight) {
//       calculateSortation();
//     } else {
//       setSortationResult({
//         mailShape: '',
//         aspectRatio: '',
//         parcelWarning: '',
//       });
//     }
//   }, [formData]);

//   // const handleDefaultSelect = (e) => {
//   //   const parts = e.target.value.split(' -');
//   //   const selectedName = parts[0];
//   //   const product = defaultProducts.find((p) => p.name === selectedName);
//   //   if (product) {
//   //     setFormData({
//   //       name: '',
//   //       weightType: product.type || 'Self Mailer',
//   //       weight: product.weight,
//   //       weightUnit: product.weightUnit || 'OZ',
//   //       thickness: product.thickness,
//   //       width: product.width,
//   //       length: product.length,
//   //       paperType: product.paperType || '',
//   //       company: company || null,
//   //       user: user._id,
//   //     });
//   //   } else {
//   //     setFormData({
//   //       name: '',
//   //       weightType: 'Self Mailer',
//   //       weight: '',
//   //       weightUnit: 'OZ',
//   //       thickness: '',
//   //       width: '',
//   //       length: '',
//   //       paperType: '',
//   //       company: company || null,
//   //       user: user._id,
//   //     });
//   //   }
//   // };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!calculateSortation()) {
//       toast.error(sortationResult.parcelWarning);
//       return;
//     }
//     formData.mailShape = sortationResult.mailShape
//     formData.aspectRatio = sortationResult.aspectRatio
//     const url = editItemId ? `${axiUrl}/products/update` : `${axiUrl}/products/add`;
//    const payload = editItemId ? { ...formData, id: editItemId } : formData;
//    console.log(payload)
//     try {
//       const res = await axios.post(url, payload);
//       await setProduct(null);
//       toast.success(res.data.message || `Product ${editItemId ? 'updated' : 'added'} successfully`);
//       await setReset(!reset);
//       onClose();
//     } catch (err) {
//       console.error('Error submitting product:', err);
//       toast.error('Error submitting product');
//     }
//   };

//   const opennewcalc = () => {
//     onClose();
//     setCalcOpen(true);
//   };

//   return (
//     <div
//       className="overflow-hidden transition-all duration-500 ease-in-out max-h-[1000px] opacity-100 translate-y-0 bg-white rounded-lg shadow-md p-6 mb-6 border-1"
//     >
//       <h2 className="text-2xl font-bold mb-4 text-gray-800">
//         {editItemId ? 'Edit Product' : 'Add Product'}
//       </h2>
//       <form onSubmit={handleSubmit} className="space-y-4">
//         <div>
//           <Label className="block text-sm font-medium text-gray-700">Name</Label>
//           <Input
//             type="text"
//             name="name"
//             value={formData?.name}
//             onChange={handleChange}
//             className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
//             required
//           />
//         </div>
//         <div className="flex gap-[10px]">
//           <div className="flex-1">
//             <Label className="block text-sm font-medium text-gray-700">Width (in)</Label>
//             <Input
//               type="number"
//               step="0.01"
//               name="width"
//               value={formData?.width}
//               onChange={handleChange}
//               className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
//               required
//             />
//           </div>
//           <div className="flex-1">
//             <Label className="block text-sm font-medium text-gray-700">Length (in)</Label>
//             <Input
//               type="number"
//               step="0.01"
//               name="length"
//               value={formData?.length}
//               onChange={handleChange}
//               className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
//               required
//             />
//           </div>
//         </div>
//         <div className="flex gap-[10px]">
//           <div className="flex flex-2 gap-[10px]">
//             <div className="flex-1">
//               <Label className="text-sm font-medium text-gray-700">Weight</Label>
//               <Input
//                 type="number"
//                 step="0.001"
//                 name="weight"
//                 value={formData?.weight}
//                 onChange={handleChange}
//                 className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
//                 required
//               />
//             </div>
//             <div>
//               <Label className="text-sm font-medium text-gray-700">&nbsp;</Label>
//               <Select
//                 name="weightUnit"
//                 value={formData?.weightUnit}
//                 onChange={handleChange}
//                 className="w-24 rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
//               >
//                 <option value="oz">oz</option>
//                 <option value="lbs">lbs</option>
//               </Select>
//             </div>
//           </div>
//           <div className="flex-1">
//             <Label className="text-sm font-medium text-gray-700">Thickness (in)</Label>
//             <Input
//               type="number"
//               step="0.001"
//               name="thickness"
//               value={formData?.thickness}
//               onChange={handleChange}
//               className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
//               required
//             />
//           </div>
//         </div>
//         <div className="flex space-x-2">
//           <div className="flex flex-col flex-1">
//             <div>Mail Shape: {sortationResult.mailShape || 'N/A'}</div>
//             <div>Aspect Ratio: {sortationResult.aspectRatio || 'N/A'}</div>
//             <div className={sortationResult.parcelWarning !== 'None' ? 'text-red-600' : ''}>
//               Warning: {sortationResult.parcelWarning || 'N/A'}
//             </div>
//           </div>
//           <div className="flex-1 flex items-end justify-end gap-10">
//             <button
//               type="button"
//               onClick={() => onClose()}
//               className="px-4 py-2 bg-gray-200 text-gray-800 rounded-md hover:bg-gray-300"
//             >
//               Cancel
//             </button>
//             <button
//               type="submit"
//               className="px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700"
//             >
//               {editItemId ? 'Update Item' : 'Add Item'}
//             </button>
//           </div>
//         </div>
//       </form>
//       <div className="mt-[20px] text-[14px] flex items-center gap-2">
//         Need help with weights or thickness? Try our product calculator.
//         <svg
//           className="block size-6"
//           xmlns="http://www.w3.org/2000/svg"
//           fill="none"
//           viewBox="0 0 24 24"
//           strokeWidth={1.5}
//           stroke="currentColor"
//           onClick={() => opennewcalc()}
//         >
//           <path
//             strokeLinecap="round"
//             strokeLinejoin="round"
//             d="M15.75 15.75V18m-7.5-6.75h.008v.008H8.25v-.008Zm0 2.25h.008v.008H8.25V13.5Zm0 2.25h.008v.008H8.25v-.008Zm0 2.25h.008v.008H8.25V18Zm2.498-6.75h.007v.008h-.007v-.008Zm0 2.25h.007v.008h-.007V13.5Zm0 2.25h.007v.008h-.007v-.008Zm0 2.25h.007v.008h-.007V18Zm2.504-6.75h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V13.5Zm0 2.25h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V18Zm2.498-6.75h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V13.5ZM8.25 6h7.5v2.25h-7.5V6ZM12 2.25c-1.892 0-3.758.11-5.593.322C5.307 2.7 4.5 3.65 4.5 4.757V19.5a2.25 2.25 0 0 0 2.25 2.25h10.5a2.25 2.25 0 0 0 2.25-2.25V4.757c0-1.108-.806-2.057-1.907-2.185A48.507 48.507 0 0 0 12 2.25Z"
//           />
//         </svg>
//       </div>
//     </div>
//   );
// };

// export default AddProduct;





import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { useAppContext } from '../../context/AppContext';
import { Label, Input, Select } from '../../Shared';
import axios from 'axios';
import getUSPSSortation from '../../util/Sortation';

const AddProduct = ({
  company,
  onClose,
  editItemId,
  setReset,
  reset,
  product,
  setProduct,
  setCalcOpen,
}) => {
  const { axiUrl, user } = useAppContext();
  const [defaultProducts, setDefaultProducts] = useState([]);
  const [sortationResult, setSortationResult] = useState({
    mailShape: '',
    aspectRatio: '',
    parcelWarning: '',
    sortation: '',
  });

  const [formData, setFormData] = useState(
    product
      ? {
          name: product.name,
          mailShape: product.mailShape || '',
          aspectRatio: product.aspectRatio || 0,
          weight: product.weight,
          weightUnit: product.weightUnit || 'OZ',
          thickness: product.thickness,
          width: product.width,
          length: product.length,
          paperType: product.paperType || '',
          company: company || null,
          user: user._id,
          isNonFlexible: product.isNonFlexible || false,
          isPolybagged: product.isPolybagged || false,
          isUnevenThickness: product.isUnevenThickness || false,
          hasLooseItems: product.hasLooseItems || false,
          mailClass: product.mailClass || 'First-Class Mail',
          sortation: product.sortation || '',
        }
      : {
          name: '',
          mailShape: '',
          aspectRatio: 0,
          weight: '',
          weightUnit: 'OZ',
          thickness: '',
          width: '',
          length: '',
          paperType: '',
          company: company || null,
          user: user._id,
          isNonFlexible: false,
          isPolybagged: false,
          isUnevenThickness: false,
          hasLooseItems: false,
          mailClass: 'First-Class Mail',
          sortation: '',
        }
  );

  useEffect(() => {
    const getdefaults = async () => {
      try {
        const res = await axios.get(`${axiUrl}/products/getdefaultproducts`);
        setDefaultProducts(res.data.data);
      } catch (err) {
        console.error('Error fetching default products:', err);
        toast.error('Failed to load default products');
      }
    };
    getdefaults();
  }, []);

  const calculateSortation = () => {
    const { width, length, thickness, weight, weightUnit, isNonFlexible, isPolybagged, isUnevenThickness, hasLooseItems, mailClass } = formData;

    const widthNum = parseFloat(width) || 0;
    const lengthNum = parseFloat(length) || 0;
    const thicknessNum = parseFloat(thickness) || 0;
    const weightNum = parseFloat(weight) || 0;

    if (widthNum <= 0 || lengthNum <= 0 || thicknessNum <= 0 || weightNum <= 0) {
      setSortationResult({
        mailShape: 'Invalid',
        aspectRatio: 'N/A',
        parcelWarning: 'Please enter valid positive values for width, length, thickness, and weight.',
        sortation: 'N/A',
      });
      return false;
    }

    // If any checkbox is checked, force Nonmachinable by setting isFlexible and isUniformThickness to false
    const isAnyCheckboxChecked = isNonFlexible || isPolybagged || isUnevenThickness || hasLooseItems;

    const sortationInput = {
      productHeight: widthNum,
      productLength: lengthNum,
      productThickness: thicknessNum,
      productWeight: weightUnit === 'lbs' ? weightNum * 16 : weightNum,
      imBarcode: true,
      isUniformThickness: !isAnyCheckboxChecked,
      isFlexible: !isAnyCheckboxChecked,
      presortOnly: false,
      mailClass: mailClass,
      quantity: 200, // Assuming default quantity for USPS Marketing Mail
    };

    console.log('Sortation Input:', sortationInput);

    const result = getUSPSSortation(sortationInput);

    setSortationResult({
      mailShape: result.error ? 'Invalid' : result.selectedCategory || 'N/A',
      aspectRatio: result.aspectRatio || 'N/A',
      parcelWarning: result.error || result.note || 'None',
      sortation: result.sortation || 'N/A',
    });

    return !result.error;
  };

  useEffect(() => {
    if (formData.width && formData.length && formData.thickness && formData.weight) {
      calculateSortation();
    } else {
      setSortationResult({
        mailShape: '',
        aspectRatio: '',
        parcelWarning: '',
        sortation: '',
      });
    }
  }, [formData]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!calculateSortation()) {
      toast.error(sortationResult.parcelWarning);
      return;
    }

    // Update formData with sortation results
    const updatedFormData = {
      ...formData,
      mailShape: sortationResult.mailShape,
      aspectRatio: sortationResult.aspectRatio,
      sortation: sortationResult.sortation,
    };

    const url = editItemId ? `${axiUrl}/products/update` : `${axiUrl}/products/add`;
    const payload = editItemId ? { ...updatedFormData, id: editItemId } : updatedFormData;
    console.log('Payload:', payload);

    try {
      const res = await axios.post(url, payload);
      await setProduct(null);
      toast.success(res.data.message || `Product ${editItemId ? 'updated' : 'added'} successfully`);
      await setReset(!reset);
      onClose();
    } catch (err) {
      console.error('Error submitting product:', err);
      toast.error('Error submitting product');
    }
  };

  const opennewcalc = () => {
    onClose();
    setCalcOpen(true);
  };

  return (
    <div
      className="overflow-hidden transition-all duration-500 ease-in-out max-h-[1000px] opacity-100 translate-y-0 bg-white rounded-lg shadow-md p-6 mb-6 border-1"
    >
      <h2 className="text-2xl font-bold mb-4 text-gray-800">
        {editItemId ? 'Edit Product' : 'Add Product'}
      </h2>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <Label className="block text-sm font-medium text-gray-700">Name</Label>
          <Input
            type="text"
            name="name"
            value={formData?.name}
            onChange={handleChange}
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
            required
          />
        </div>
        <div>
          <Label className="block text-sm font-medium text-gray-700">Mail Class</Label>
          <Select
            name="mailClass"
            value={formData?.mailClass}
            onChange={handleChange}
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
            required
          >
            <option value="First-Class Mail">First-Class Mail</option>
            <option value="USPS Marketing Mail">USPS Marketing Mail</option>
          </Select>
        </div>
        <div className="flex gap-[10px]">
          <div className="flex-1">
            <Label className="block text-sm font-medium text-gray-700">Width (in)</Label>
            <Input
              type="number"
              step="0.01"
              name="width"
              value={formData?.width}
              onChange={handleChange}
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
              required
            />
          </div>
          <div className="flex-1">
            <Label className="block text-sm font-medium text-gray-700">Length (in)</Label>
            <Input
              type="number"
              step="0.01"
              name="length"
              value={formData?.length}
              onChange={handleChange}
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
              required
            />
          </div>
        </div>
        <div className="flex gap-[10px]">
          <div className="flex flex-2 gap-[10px]">
            <div className="flex-1">
              <Label className="text-sm font-medium text-gray-700">Weight</Label>
              <Input
                type="number"
                step="0.001"
                name="weight"
                value={formData?.weight}
                onChange={handleChange}
                className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
                required
              />
            </div>
            <div>
              <Label className="text-sm font-medium text-gray-700">&nbsp;</Label>
              <Select
                name="weightUnit"
                value={formData?.weightUnit}
                onChange={handleChange}
                className="w-24 rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
              >
                <option value="oz">oz</option>
                <option value="lbs">lbs</option>
              </Select>
            </div>
          </div>
          <div className="flex-1">
            <Label className="text-sm font-medium text-gray-700">Thickness (in)</Label>
            <Input
              type="number"
              step="0.001"
              name="thickness"
              value={formData?.thickness}
              onChange={handleChange}
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
              required
            />
          </div>
        </div>
        <div className="flex flex-wrap gap-4">
          <div className="flex items-center">
            <Input
              type="checkbox"
              name="isNonFlexible"
              checked={formData?.isNonFlexible}
              onChange={handleChange}
              className="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded"
            />
            <Label className="ml-2 text-sm font-medium text-gray-700">Non-Flexible</Label>
          </div>
          <div className="flex items-center">
            <Input
              type="checkbox"
              name="isPolybagged"
              checked={formData?.isPolybagged}
              onChange={handleChange}
              className="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded"
            />
            <Label className="ml-2 text-sm font-medium text-gray-700">Polybagged</Label>
          </div>
          <div className="flex items-center">
            <Input
              type="checkbox"
              name="isUnevenThickness"
              checked={formData?.isUnevenThickness}
              onChange={handleChange}
              className="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded"
            />
            <Label className="ml-2 text-sm font-medium text-gray-700">Uneven Thickness</Label>
          </div>
          <div className="flex items-center">
            <Input
              type="checkbox"
              name="hasLooseItems"
              checked={formData?.hasLooseItems}
              onChange={handleChange}
              className="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded"
            />
            <Label className="ml-2 text-sm font-medium text-gray-700">Loose Items (Cards, Keys, Other)</Label>
          </div>
        </div>
        <div className="flex space-x-2">
          <div className="flex flex-col flex-1">
            <div>Mail Shape: {sortationResult.mailShape || 'N/A'}</div>
            <div>Aspect Ratio: {sortationResult.aspectRatio || 'N/A'}</div>
            <div>Sortation: {sortationResult.sortation || 'N/A'}</div>
            <div className={sortationResult.parcelWarning !== 'None' ? 'text-red-600' : ''}>
              Warning: {sortationResult.parcelWarning || 'N/A'}
              {sortationResult.mailShape === 'Parcels' && (
                <div style={{ color: 'red' }}>Warning: Parcels are not handled in this service.</div>
              )}
            </div>
          </div>
          <div className="flex-1 flex items-end justify-end gap-10">
            <button
              type="button"
              onClick={() => onClose()}
              className="px-4 py-2 bg-gray-200 text-gray-800 rounded-md hover:bg-gray-300"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700"
            >
              {editItemId ? 'Update Item' : 'Add Item'}
            </button>
          </div>
        </div>
      </form>
      {/* <div className="mt-[20px] text-[14px] flex items-center gap-2">
        Need help with weights or thickness? Try our product calculator.
        <svg
          className="block size-6"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={1.5}
          stroke="currentColor"
          onClick={() => opennewcalc()}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M15.75 15.75V18m-7.5-6.75h.008v.008H8.25v-.008Zm0 2.25h.008v.008H8.25V13.5Zm0 2.25h.008v.008H8.25v-.008Zm0 2.25h.008v.008H8.25V18Zm2.498-6.75h.007v.008h-.007v-.008Zm0 2.25h.007v.008h-.007V13.5Zm0 2.25h.007v.008h-.007v-.008Zm0 2.25h.007v.008h-.007V18Zm2.504-6.75h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V13.5Zm0 2.25h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V18Zm2.498-6.75h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V13.5ZM8.25 6h7.5v2.25h-7.5V6ZM12 2.25c-1.892 0-3.758.11-5.593.322C5.307 2.7 4.5 3.65 4.5 4.757V19.5a2.25 2.25 0 0 0 2.25 2.25h10.5a2.25 2.25 0 0 0 2.25-2.25V4.757c0-1.108-.806-2.057-1.907-2.185A48.507 48.507 0 0 0 12 2.25Z"
          />
        </svg>
      </div> */}
    </div>
  );
};

export default AddProduct;